import { FC } from 'react';
import {
  EntitySearchTextFilter,
  EntityTagPicker,
  UserListPicker,
  WbTableFilters,
} from '@agilelab/plugin-wb-platform';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { useEntityList } from '@backstage/plugin-catalog-react';

export const BlueprintListFilters: FC = () => {
  const { filters, updateFilters } = useEntityList();
  const configApi = useApi(configApiRef);

  return (
    <WbTableFilters
      searchValue={filters.text?.value}
      onSearch={value => {
        updateFilters({ text: new EntitySearchTextFilter(value, configApi) });
      }}
      onClear={() => {
        updateFilters({
          type: undefined,
          tags: undefined,
          user: undefined,
          text: undefined,
        });
      }}
    >
      <EntityTagPicker />
      <UserListPicker />
    </WbTableFilters>
  );
};
